import { render, staticRenderFns } from "./enteredMenu.vue?vue&type=template&id=39f554be&scoped=true&"
import script from "./enteredMenu.vue?vue&type=script&lang=js&"
export * from "./enteredMenu.vue?vue&type=script&lang=js&"
import style0 from "./enteredMenu.vue?vue&type=style&index=0&id=39f554be&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39f554be",
  null
  
)

export default component.exports